import { JadwalServicePage } from '..'

const MekanikJadwalServicePage = () => {
  return <JadwalServicePage isMechanicView={true} />
}

export default MekanikJadwalServicePage
